export default __webpack_public_path__ + "static/media/lrs-logo.22058dd9.svg";